//------------------------------------------------------------------------
// Import Main Styles
//------------------------------------------------------------------------
require('../styles/main.scss');

//------------------------------------------------------------------------
// Import Bootstrap
//------------------------------------------------------------------------
import 'bootstrap';

//------------------------------------------------------------------------
// Import Cookie Consent
//------------------------------------------------------------------------
import 'vanilla-cookieconsent';

//------------------------------------------------------------------------
// Vanilla LazyLoad
//------------------------------------------------------------------------
import LazyLoad from "vanilla-lazyload";

var pageLazyBg = new LazyLoad({
  elements_selector: ".lazy-bg",
  threshold: 50,
  callback_loaded: (el) => {
    el.classList.add('bg-loaded');
  }
});

pageLazyBg.update();

//------------------------------------------------------------------------
// Import Custom Modules
//------------------------------------------------------------------------
import './modules/announcement-bar.js';
import './modules/load-more.js';
import './modules/navbar.js';
import './modules/smooth-scroll';
import './modules/newsletter-popup.js';
import './modules/video-modal.js';
import Anchors from './modules/anchors';
import AnimateContent from './modules/animate-content';
import Stats from './modules/stats';
import StickyNav from './modules/sticky-nav';
import Testimonials from './modules/testimonials';
import VideoInview from './modules/video-inview.js';
import VideoLazy from './modules/video-lazy.js';

//------------------------------------------------------------------------
// Init Functions on Window Load
//------------------------------------------------------------------------
window.onload = function () {
  AnimateContent();
  Anchors();
  Stats();
  StickyNav();
  Testimonials();
  VideoInview();
  VideoLazy();
};
  